import { render, staticRenderFns } from "./wrapperObjectiveListMinima.vue?vue&type=template&id=63132f49&"
import script from "./wrapperObjectiveListMinima.vue?vue&type=script&lang=js&"
export * from "./wrapperObjectiveListMinima.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports